import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type BillingPlan from 'webapp/models-custom/billing-plan';

interface QueryParams {
	planId?: string;
}

export default class SettingsBillingRoute extends Route {
	@service('billing') declare billingService: Service.Billing;

	override queryParams = {
		planId: {
			refreshModel: true,
		},
	};

	override beforeModel(): void {
		document.body.id = 'page-account-billing';
	}

	override model(params: QueryParams): BillingPlan | null {
		const planId = params.planId!;
		return planId ? this.billingService.findPlan(planId) : null;
	}

	override afterModel(model: BillingPlan | null): void {
		if (model) {
			this.billingService.switchPlan(model, {
				billingPeriodChangePopup: 'email_upgrade_request',
			});
		}
	}
}
